export default function Countdown() {

	const element = document.querySelector('.js-countdown');

	if (!element) {
		return;
	}

	function getTimerRemaining(endtime) {
		const diff = endtime - Date.parse(new Date());

		let seconds = Math.floor((diff / 1000) % 60);
		if (seconds <= 9) {
			seconds = '0' + seconds;
		}

		let minutes = Math.floor((diff / 1000 / 60) % 60);
		if (minutes <= 9) {
			minutes = '0' + minutes;
		}

		let hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
		if (hours <= 9) {
			hours = '0' + hours;
		}

		let days = Math.floor(diff / (1000 * 60 * 60 * 24));
		if (days <= 9) {
			days = '0' + days;
		}

		return {
			'total': diff.toString(),
			'days': days.toString(),
			'hours': hours.toString(),
			'minutes': minutes.toString(),
			'seconds': seconds.toString()
		};
	}

	function initializeClock(endtime) {
		let daysSpan = document.querySelector('.js-countdown-days');
		let hoursSpan = document.querySelector('.js-countdown-hours');
		let minutesSpan = document.querySelector('.js-countdown-minutes');
		let secondsSpan = document.querySelector('.js-countdown-seconds');

		function updateClock() {
			let time = getTimerRemaining(endtime);

			daysSpan.textContent = time.days;
			hoursSpan.textContent = time.hours;
			minutesSpan.textContent = time.minutes;
			secondsSpan.textContent = time.seconds;

			if (time.total <= 0) {
				daysSpan.textContent = '00';
				hoursSpan.textContent = '00';
				minutesSpan.textContent = '00';
				secondsSpan.textContent = '00';

				element.style.display = 'none';
				clearInterval(timerInterval);
			} else {
				if (element.style.display === 'none') {
					element.style.display = 'block';
				}
			}
		}

		updateClock();
		let timerInterval = setInterval(updateClock, 1000);
	}

	let deadline = parseInt(element.getAttribute('data-date')) * 1000;

	if (parseInt(element.getAttribute('data-bst')) === 1) {
		deadline -= 3600000;
	}

	initializeClock(deadline);

}
